'use strict';

var React = require('react'),
    ReactDOM = require('react-dom'),
    RectIcon = require('../Icon/RectIcon');

var ScrollArea = React.createClass({
    displayName: 'ScrollArea',


    getDefaultProps: function getDefaultProps() {
        return {
            height: "auto"
        };
    },

    getInitialState: function getInitialState() {
        return {
            showHandelsTop: false,
            showHandelsBottom: false
        };
    },

    componentDidMount: function componentDidMount() {
        this._updateHandels();

        var el = ReactDOM.findDOMNode(this.refs["scroll-area-inner-wrap"]);
        el.addEventListener('scroll', this.onContentScroll);
    },

    componentWillUnmount: function componentWillUnmount() {
        var el = ReactDOM.findDOMNode(this.refs["scroll-area-inner-wrap"]);
        el.addEventListener('scroll', this.onContentScroll);
    },

    onContentScroll: function onContentScroll() {
        this._updateHandels();
    },

    _updateHandels: function _updateHandels() {
        var innerWrap = ReactDOM.findDOMNode(this.refs["scroll-area-inner-wrap"]);
        var scrollTop = innerWrap.scrollTop;
        var totalHeight = ReactDOM.findDOMNode(this.refs["scroll-area"]).clientHeight;
        var innerHeight = ReactDOM.findDOMNode(this.refs["scroll-area-inner"]).clientHeight;
        var innerWrapHeight = innerWrap.clientHeight;

        var showHandelsTop = false;
        var showHandelsBottom = false;

        if (innerHeight > totalHeight) {
            if (scrollTop > 0) {
                showHandelsTop = true;
            }
            if (scrollTop + innerWrapHeight < innerHeight) {
                showHandelsBottom = true;
            }
        } else {
            showHandelsTop = false;
            showHandelsBottom = false;
        }

        var state = this.state;

        if (showHandelsTop != state.showHandelsTop || showHandelsBottom != state.showHandelsBottom) {
            state.showHandelsTop = showHandelsTop;
            state.showHandelsBottom = showHandelsBottom;
            this.setState(state);
        }
    },

    scrollTop: function scrollTop(e) {
        var el = ReactDOM.findDOMNode(this.refs["scroll-area-inner-wrap"]);
        if (this.state.showHandelsTop) {
            el.scrollTop -= 10;
        } else {
            clearInterval(this.intervalScroll);
            this.intervalScroll = undefined;
        }
    },

    scrollBottom: function scrollBottom(e) {
        if (this.state.showHandelsBottom) {
            var el = ReactDOM.findDOMNode(this.refs["scroll-area-inner-wrap"]);
            el.scrollTop += 10;
        } else {
            clearInterval(this.intervalScroll);
            this.intervalScroll = undefined;
        }
    },

    onScrollBottomStart: function onScrollBottomStart(e) {
        if (this.intervalScroll == undefined) {
            this.intervalScroll = setInterval(this.scrollBottom, 100);
        }

        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
    },

    onScrollTopStart: function onScrollTopStart(e) {
        if (this.intervalScroll == undefined) {
            this.intervalScroll = setInterval(this.scrollTop, 100);
        }

        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
    },

    onScrollTopEnd: function onScrollTopEnd(e) {
        clearInterval(this.intervalScroll);
        this.intervalScroll = undefined;

        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
    },

    onScrollBottomEnd: function onScrollBottomEnd(e) {
        clearInterval(this.intervalScroll);
        this.intervalScroll = undefined;

        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
    },

    scrollToRect: function scrollToRect(top, bottom) {
        var el = ReactDOM.findDOMNode(this.refs["scroll-area-inner-wrap"]);

        if (top < el.scrollTop) {
            el.scrollTop = top;
        } else if (bottom > el.scrollTop + el.offsetHeight) {
            el.scrollTop = bottom - el.offsetHeight;
        }
    },

    render: function render() {
        var handleTop;
        var handleBottom;

        if (this.state.showHandelsTop) {
            handleTop = React.createElement(
                'div',
                { className: 's-a-knob clickable', onMouseDown: this.onScrollTopStart, onMouseUp: this.onScrollTopEnd },
                '   ',
                React.createElement(RectIcon, { imgSrc: 'img/arrow-top.png' }),
                '   '
            );
        }
        if (this.state.showHandelsBottom) {
            handleBottom = React.createElement(
                'div',
                { className: 's-a-knob clickable', onMouseDown: this.onScrollBottomStart, onMouseUp: this.onScrollBottomEnd },
                React.createElement(RectIcon, { imgSrc: 'img/arrow-bottom.png' })
            );
        }

        var style = { maxHeight: this.props.height };

        return React.createElement(
            'div',
            { className: 'scroll-area', ref: 'scroll-area' },
            handleTop,
            React.createElement(
                'div',
                { className: 'scroll-area-inner-wrap', style: style, ref: 'scroll-area-inner-wrap' },
                React.createElement(
                    'div',
                    { className: 'scroll-area-inner', ref: 'scroll-area-inner' },
                    this.props.children
                )
            ),
            handleBottom
        );
    }

});

module.exports = ScrollArea;


//////////////////
// WEBPACK FOOTER
// ./node_modules/fdna-common-components/dist/components/ScrollArea/ScrollArea.js
// module id = 453
// module chunks = 0 1 2 3 5 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26